import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../material.module';
import { TranslateModule } from '@ngx-translate/core';

interface SubscriptionType {
  name: string;
  description: string;
  icon: string;
}

@Component({
  selector: 'app-subscription-success',
  standalone: true,
  imports: [CommonModule, MaterialModule, TranslateModule],
  templateUrl: './subscription-success.component.html',
  styleUrl: './subscription-success.component.scss'
})
export class SubscriptionSuccessComponent implements OnInit {
  subscriptionType: string = '';
  subscriptionInfo: SubscriptionType | null = null;
  sessionId: string = '';

  // Configuración de tipos de suscripción con claves de traducción
  private subscriptionTypes: { [key: string]: SubscriptionType } = {
    'ai-posture-analysis': {
      name: 'SUBSCRIPTION_SUCCESS.AI_POSTURE_ANALYSIS_NAME',
      description: 'SUBSCRIPTION_SUCCESS.AI_POSTURE_ANALYSIS_DESC',
      icon: 'psychology'
    },
    'premium': {
      name: 'SUBSCRIPTION_SUCCESS.PREMIUM_NAME',
      description: 'SUBSCRIPTION_SUCCESS.PREMIUM_DESC',
      icon: 'workspace_premium'
    },
    'basic': {
      name: 'SUBSCRIPTION_SUCCESS.BASIC_NAME',
      description: 'SUBSCRIPTION_SUCCESS.BASIC_DESC',
      icon: 'check_circle'
    }
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Obtener parámetros de la URL
    this.route.queryParams.subscribe(params => {
      this.sessionId = params['session_id'] || '';
      this.subscriptionType = params['subscription_type'] || 'ai-posture-analysis';
      
      // Obtener información de la suscripción o usar valores por defecto
      this.subscriptionInfo = this.subscriptionTypes[this.subscriptionType] || {
        name: 'SUBSCRIPTION_SUCCESS.DEFAULT_NAME',
        description: 'SUBSCRIPTION_SUCCESS.DEFAULT_DESC',
        icon: 'check_circle'
      };
    });
  }

  goToDashboard(): void {
    this.router.navigate(['/']);
  }
}
